const widgets = {};

export default widgets
